import React from 'react';

interface IOverviewBottom {
    leafName: string;
    leafPath: string;
    bottomHeight: number;
}

function OverviewBottom(props: IOverviewBottom) {
    const { leafName, leafPath, bottomHeight } = props;

    return (
        <div className="overview-main__bottom" style={{ height: `${bottomHeight}%`, userSelect: 'none' }}>
            <div className="overview-main__comment">
                <div className="overview-main__comment__name">Comment</div>
                <div className="overview-main__comment__value" title={leafName}>
                    {leafName}
                </div>
            </div>
            <div className="overview-main__address">
                <div className="overview-main__address__name">Address</div>
                <div className="overview-main__address__value" title={leafPath}>
                    {leafPath}
                </div>
            </div>
            <div style={{ height: 'calc(100% - 66px)', border: '1px solid', borderColor: '#808080 #fff #fff #808080' }}>
                <div className="overview-main__bottom-win"></div>
            </div>
            <div className="overview-main__search-btn">Search</div>
        </div>
    );
}

export default OverviewBottom;
